
import { computed, defineComponent, reactive, ref } from "vue";
import { useStore } from "vuex";
import { notice, timeStampToTime, Toast } from "@/utils";

import {
  saveTransDeptRequirement,
  uploadTransDeptFile,
} from "@/request/view/transDept";

import {
  getRenderForm,
  setDefaultValue,
  getNextProgress,
  getCurrentProgress,
  findDepartMentLeader,
  getProgressIndexName,
  completionTimeLine,
  requirementProgress,
  insertStep,
  examineStep,
  receiveStep,
  executeStep,
  deliveryTasksStep,
  deliveryConfirmationStep,
  closeStep,
} from "@/views/departmentalRequirements/serve";

import { sendMessage } from "@/views/departmentalRequirements/socketToast";
import { formState, rules } from '@/views/departmentalRequirements/formData';

import upload from "@/views/rdmanagement/components/database/upload.vue";
import selectDepartment from "@/views/departmentalRequirements/components/selectDepartment.vue";
import staff from '@/components/chooseStaff/staff.vue';

export default defineComponent({
  components: { upload, selectDepartment, staff },
  setup(props, context) {
    const store = useStore();

    const { firstLevelDepartment, nickName, id } = store.state.user.user;

    const modalConfig = reactive({
      visible: false,
      title: null,
      type: null,
    });

    const formRef = ref();

    // 转化请求数据
    const getUploadForm = () => {
      const formData = {};
      Object.keys(formState).forEach((key) => {
        if (formState[key] && formState[key].value === null) return;
        formData[key] = formState[key].value;
      });

      return formData;
    };

    const setFormField = (fileList) => {
      fileList.forEach((item) => {
        formState[item.fileName].show = true;
        formState[item.fileName].disabled = item.disabled;
      });
    };

    // 上传文件
    const setUploadFileUrl = (url) => {
      formState.requirementFile.value = url;
    };

    const setDeliveryFile = (url) => {
      formState.deliveryFile.value = url;
    };

    /**
     * 重置表单
     * */
    const resetForm = () => {
      formRef.value.clearValidate();

      Object.keys(formState).forEach((key) => {
        formState[key].value = null;
        formState[key].disabled = false;
        formState[key].show = false;
      });

      modalConfig.title = null;
      modalConfig.type = null;
    };

    const handleCancel = () => {
      resetForm();
      modalConfig.visible = false;
    };


    /**
     * 任务负责人修改权限
    */
   const executorAuthority = computed(() => {
      if (!formState.completeRequirementDept.value) return false;
      const leader = findDepartMentLeader(formState.completeRequirementDept.value);

      let isLeader = false;

      if (leader) {
        isLeader = leader.nickName === nickName;
      }

      const isExecutor = formState.executor.value === nickName;
      
      const isChangeExcutor = modalConfig.type === 'changeExcutor';

      return isLeader || isExecutor || isChangeExcutor;
   });

   const isDepartmentLeaderInsert = (uploadData) => {
      let isLeader = false;
      if (modalConfig.type !== 'insert') return isLeader; 
      const leader = findDepartMentLeader(uploadData.demanderDept);

      if (leader && leader.id == store.state.user.user.id) {
        isLeader = true;
      }

      return isLeader;
   };

    /**
     * 表单提交
     */
    const handleOk = () => {
      formRef.value
        .validate()
        .then((res) => {
          const uploadData :any = getUploadForm();
          if (modalConfig.type === 'examine') {

          }

          if (modalConfig.type === 'deliveryconfirmation') {
            uploadData.progress[4] = deliveryConfirmationStep(nickName, uploadData.requirementDeliveryConfirmation);
          }

          if (modalConfig.type === 'deliveryconfirmation' && uploadData.requirementDeliveryConfirmation === '确认') {
            uploadData.progress[5] = closeStep();
          }

          if (typeof uploadData.progress === 'object') {
            uploadData.progress = JSON.stringify(uploadData.progress);
          }
          
          console.log(uploadData, '上传的数据是');
          // saveTransDeptRequirement(uploadData).then((res: any) => {
          //   sendMessage(modalConfig.type, uploadData);
          //   const type = res.code === 200 ? 'success' : 'warning';
          //   Toast(type, res.message, 3);
          //   handleCancel();
          //   context.emit('updateTable');
          // });

        })
        .catch((err) => {
          console.log(err);
          if (err.errorFields) {
            const [errText] = err.errorFields[0].errors;

            Toast("warning", errText, 3);
          }
        });
    };
    // 选择期望交付日期
    const handleSelectDate = (e, stringTime) => {
      formState.expectedDeliveryDate.value = stringTime;
    };

    // 选择需求完成部门
    const handleSelectDepartment = (department) => {
      formState.completeRequirementDept.value = department;
    };

    // 选择任务负责人
    const getChooseStaff = (data) => {
      const { idList, staffUserName } = data;
      const chooseUsername = staffUserName[0];
      const chooseUserId = idList[0];

      formState.executor.value = chooseUsername;
      formState.executorId.value = chooseUserId;

      formState.progress.value[2] = executeStep(chooseUsername);

      console.log(formState.progress.value);
    };

    // 是否接受需求
    const handleIsReceiveChange = (isReceive: boolean) => {
      const receiveIndex = 2;
      
      let handleIndex = isReceive ? receiveIndex + 1 : receiveIndex - 1;

      formState.isReceive.value = isReceive;
      formState.receiveDate.value = new Date();
      if (isReceive === undefined) {
        handleIndex = 2;
        formState.isReceive.value = null;
        formState.receiveDate.value = null;
      }

      formState.progress.value[1] = receiveStep(nickName, isReceive);

    };

    // 是否交付需求
    const handleIsDeliveryChange = (isDelivery: boolean) => {
      const receiveIndex = 4;
      
      let handleIndex = isDelivery ? receiveIndex + 1 : receiveIndex - 1;

      formState.isDelivery.value = isDelivery;

      formState.deliveryDate.value = new Date();

      if (isDelivery === undefined) {
        handleIndex = 4;
        formState.isDelivery.value = null;
      }
      // formState.progress.value = getProgressIndexName(handleIndex);

      formState.progress.value[3] = deliveryTasksStep(nickName);

      console.log(formState.progress.value);
    };

    // 确认交付
    const handleDelConfirmChange = (confirmation) => {
      const isConfirm = confirmation === '确认';

      console.log(isConfirm, confirmation);

      const receiveIndex = 5;
      
      let handleIndex = isConfirm ? receiveIndex + 1 : receiveIndex - 1;

      formState.requirementDeliveryConfirmation.value = confirmation;

      if (isConfirm === undefined) {
        handleIndex = 5;
        formState.requirementDeliveryConfirmation.value = null;
      }

      if (confirmation === '进行中') {
        handleIndex = 5;
        return
      }
    };

    
    /**
     * 打开表单对数据进行处理
     * insert 新增跨部门需求 处理默认需求发起人 发起部门 领导审核人
     * examine 审核将流程设置
     */
    const showModal = (option) => {
      const { title, type, data } = option;
      modalConfig.title = title;
      modalConfig.type = type;
      // 新增
      if (type === "insert") {
        const list = getRenderForm("demand");
        setFormField(list);
        formState.demander.value = nickName;
        formState.demanderDept.value = firstLevelDepartment;
        formState.demanderId.value = id;
        formState.proposedTime.value = new Date();
        const leader = findDepartMentLeader(formState.demanderDept.value);
        if (leader) {
            formState.demanderDeptHead.value = leader.nickName;
        }
      }

      // 更新
      if (type === "update") {
        const list = getRenderForm("demand");
        setFormField(list);
        Object.keys(formState).forEach((key) => {
          formState[key].value = data[key];
        });
      }

      // 审核
      if (type === 'examine') {
        // const progress = getCurrentProgress(data.progress);
        const progress =  requirementProgress[data.status];

        const list = getRenderForm((progress as any).value );
        setFormField(list);
        Object.keys(formState).forEach((key) => {
          formState[key].value = data[key];
        });
        // const next = getNextProgress(data.progress);
        // formState.progress.value = next.name;
        formState.progress.value[data.status] = examineStep(nickName);
        formState.pushDate.value = timeStampToTime('', 'upload');
        formState.isPush.value = true;
        formState.isReceive.value = null;
      }

      // 接收需求
      if (type === 'receive') {
        // const progress = getCurrentProgress(data.progress);
        const progress =  requirementProgress[data.status];
        const list = getRenderForm((progress as any).value );
        setFormField(list);
        Object.keys(formState).forEach((key) => {
          formState[key].value = data[key];
        });
        handleIsReceiveChange(formState.isReceive.value);
        rules.executor[0].required = false;
      }
      // 更换需求执行人
      if (type === 'changeExcutor') {
         const progress =  requirementProgress[data.status];
        const list = getRenderForm((progress as any).value );
        setFormField(list);
        Object.keys(formState).forEach((key) => {
          formState[key].value = data[key];
        });
        formState.isReceive.show = false;
        formState.isDelivery.show = false;
        formState.deliveryFile.show = false;
        rules.executor[0].required = true;
      }

      // 交付需求
      if (type === 'deliver') {
        const progress = requirementProgress[data.status];
        const list = getRenderForm((progress as any).value);
        setFormField(list);
        Object.keys(formState).forEach((key) => {
          formState[key].value = data[key];
        });
        formState.executor.show = false;
        handleIsDeliveryChange(formState.isDelivery.value);
      }

      // 交付需求确认
      if (type === 'deliveryconfirmation') {
        const progress = requirementProgress[data.status];
        const list = getRenderForm((progress as any).value );
        console.log(list, progress);
        setFormField(list);
        Object.keys(formState).forEach((key) => {
          formState[key].value = data[key];
        });
        handleDelConfirmChange(formState.requirementDeliveryConfirmation.value);
      }

      modalConfig.visible = true;
    };

    return {
      modalConfig,
      handleOk,
      handleCancel,
      setUploadFileUrl,
      setDeliveryFile,
      showModal,
      formState,
      formRef,
      rules,
      executorAuthority,
      handleSelectDate,
      handleSelectDepartment,
      uploadTransDeptFile,
      getChooseStaff,
      handleIsReceiveChange,
      handleIsDeliveryChange,
      handleDelConfirmChange,
    };
  },
});
